import React from 'react';

interface IProps {
  children: React.ReactNode,
}

const BodyWrapper = ({ children }: IProps) => (
  <tbody>
    { children }
  </tbody>
);

export default BodyWrapper;
